@if (msisdnList.length == 0) {
    <div class="lines-list-area text-center mt-4 pt-3">Aucune ligne n'est associée à ce compte.</div>
}
@if (msisdnList.length > 0) {
    <div class="lines-list-area">
        <div class="choice-line-concerned-area"
             [ngClass]="{'pointer-cursor': selectedProcedure === null || selectedProcedure == ''}"
             (click)="linesListVisibility()">
            <div class="line-header">
                <div class="selected-line-desc">
                    <strong>Ligne : </strong><span>{{ selectedLine.phoneNumber }}</span>
                    @if (selectedLine) {
                        <app-dot [ngStyle]="{position: 'relative', top: '9px', marginRight: '10px'}"
                                 [dynamicStatus]="selectedLine.status"></app-dot>
                    }
                    <span class="line-label">{{ selectedLine.description.substr(0, 25) }}</span>
                </div>
                @if (msisdnList.length > 1 && (selectedProcedure == null || selectedProcedure == '')) {
                    <div class="change-line-select">
                        <span class="change-line-select_txt">Changer de ligne</span>
                        @if (msisdnList.length > 1) {
                            <img src="../../../../../assets/images/icons/{{ arrowImage }}.png">
                        }
                    </div>
                }
                @if (selectedProcedure && selectedProcedure !== '') {
                    <div class="change-line-select-dummy"></div>
                }<!--.change-line-select-->
            </div>
        </div><!--.choice-line-concerned-area-->
        @if (msisdnList.length > 1) {
            <app-modal-lines-list [msisdnList]="msisdnList" [visibility]="visibility"
                                  (closedListLines)="listLinesStatus($event)"></app-modal-lines-list>
        }
        <div class="tabs-area icon-tab line-details-{{ brand }}">
            <nav>
                <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                    <a class="nav-item nav-link left-border-tab {{ consumptionTab }}"
                       (click)="setActiveTab('suiviconso', true, false)" id="nav-consumption-tab"
                       data-toggle="tab" href="#nav-consumption" role="tab" aria-controls="nav-consumption"
                       aria-selected="true">
                        <span class="nav-icon suivi-conso-icon"></span>
                        <span class="nav-txt">SUIVI CONSO</span>
                    </a>
                    <a class="nav-item nav-link left-border-tab {{ documentsTab }}"
                       (click)="setActiveTab('infos', false, false)" id="nav-documents-tab"
                       data-toggle="tab" href="#nav-documents" role="tab" aria-controls="nav-documents"
                       aria-selected="false">
                        <span class="nav-icon info-doc-icon"></span>
                        <span class="nav-txt">INFOS et DOCUMENTS</span>
                    </a>
                    <a class="nav-item nav-link left-border-tab {{ lineManagementTab }}"
                       (click)="setActiveTab('gestion', false, false)" id="nav-line-management-tab"
                       data-toggle="tab" href="#nav-line-management" role="tab" aria-controls="nav-line-management"
                       aria-selected="false">
                        <span class="nav-icon gestion-ligne-icon"></span>
                        <span class="nav-txt">GESTION DE MA LIGNE</span>
                    </a>
                    @if (notificationsPaginator.data.length > 0) {
                        <a class="nav-item nav-link left-border-tab right-border-tab {{ notificationsTab }}"
                           (click)="setActiveTab('notifications', false, false)" id="nav-notifications-tab"
                           data-toggle="tab" href="#nav-notifications"
                           role="tab" aria-controls="nav-notifications" aria-selected="false">
                            <span class="nav-txt">NOTIFICATIONS</span>
                            <app-notif-bell [notificationsNumber]="notificationsPaginator?.totalUnread"
                                            [className]="'alt-lines-list'"></app-notif-bell>
                        </a>
                    }
                </div>
            </nav>
            <!-- ************************************************************************************  Suivi conso ******************************************  ****************************************** -->
            <div class="tab-content p-3" id="nav-tabContent">
                <div class="tab-pane fade show {{ consumptionTab }}" id="nav-consumption" role="tabpanel"
                     aria-labelledby="nav-consumption-tab">
                    @if (consumptionTab != '') {
                        <app-consumption [selectedLine]="selectedLine"></app-consumption>
                    }
                </div>
                <!-- ************************************************************************************  Info et documents ******************************************  ****************************************** -->
                <div class="tab-pane fade show {{ documentsTab }}" id="nav-documents" role="tabpanel"
                     aria-labelledby="nav-documents-tab">
                    @if (documentsTab != '') {
                        <app-line-details></app-line-details>
                    }
                </div>
                <!-- ************************************************************************************  Gestion de ma ligne ******************************************  ****************************************** -->
                <div class="tab-pane fade show {{ lineManagementTab }}" id="nav-line-management" role="tabpanel"
                     aria-labelledby="nav-line-management-tab">
                    @if (lineManagementTab != '') {
                        <app-line-management [procedureInParam]="procedureInParam"></app-line-management>
                    }
                </div>
                <!-- ************************************************************************************  Notifications ******************************************  ****************************************** -->
                @if (notificationsPaginator.data.length > 0) {
                    <div class="tab-pane fade show {{ notificationsTab }}" id="nav-notifications" role="tabpanel"
                         aria-labelledby="nav-notifications-tab"
                    >
                        @if (notificationsTab != '') {
                            <app-notifications [notificationsPaginator]="notificationsPaginator"
                                               [selectedLine]="selectedLine" [type]="'msisdn'"></app-notifications>
                        }
                    </div>
                }
            </div>
        </div><!--.tabs-area-->
    </div>
}<!--.lines-list-area-->
@if (null === msisdnList) {
    <div class="text-center mt-4 pt-3">Aucune ligne n'est associée à ce compte.</div>
}

<app-frequently-questions [faq]="faqPageCode"></app-frequently-questions>
